<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div v-else>
      <div v-for="(field, index) in fields" :key="field.id">
        <div class="row d-flex">
          <div class="col-md-5">
            <b-form-group
              class="mb-3 form-label"
              label="Qual o tipo de deficiência?"
            >
              <multiselect
                v-model="field.tipoDeficiencia"
                placeholder="Selecione"
                label="nm_deficiencia"
                :options="optionTipoDeficiencia"
                track-by="sq_deficiencia"
                :show-labels="false"
                :allow-empty="false"
                :disabled="field.salvo"
              >
                <span slot="noResult">Nenhum resultado encontrado.</span>
              </multiselect>
            </b-form-group>
          </div>
          <div class="col-md-5">
            <b-form-group class="mb-3 form-label" label="Informe o CID">
              <b-form-input
                v-model="field.dsCid"
                type="text"
                autocomplete="off"
                maxlength="10"
                :disabled="field.salvo"
                trim
              ></b-form-input>
            </b-form-group>
          </div>
          <div
            class="col-md-2 d-flex justify-content-end align-items-center mt-1"
          >
            <div class="justify-content-start">
              <b-button
                variant="success"
                class="mt-1 me-1 d-flex font-size-13"
                @click="salvar(field, index)"
                v-if="!(field.salvo || indexLoading === index)"
                data-tooltip="Salvar"
                data-tooltip-location="bottom"
              >
                <i class="mdi mdi-content-save"></i>
                <b-spinner
                  variant="primary"
                  small
                  class="ms-2"
                  v-if="loadingSalvar && indexLoading === index"
                ></b-spinner>
              </b-button>
            </div>
            <div class="justify-content-end">
              <b-button
                variant="danger"
                class="mt-1 me-1 d-flex font-size-13"
                @click="deleteRow(field, index)"
                :disabled="loadingDeletar && indexLoading === index"
                data-tooltip="Excluir"
                data-tooltip-location="bottom"
              >
                <i class="mdi mdi-trash-can"></i>
                <b-spinner
                  variant="primary"
                  small
                  class="ms-2"
                  v-if="loadingDeletar && indexLoading === index"
                ></b-spinner>
              </b-button>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="mt-2 d-flex justify-content-end">
          <b-button
            variant="info"
            @click="AddformData"
            :disabled="travaAdicionar"
          >
            <i class="mdi mdi-plus"></i>
            Incluir
          </b-button>
        </div>
      </div>

      <div class="row">
        <div class="mt-1 d-flex justify-content-between">
          <b-button
            class="mt-1 me-1"
            @click="navegar('dadosPessoais', false)"
            data-tooltip="Voltar"
            data-tooltip-location="bottom"
          >
            <i class="mdi mdi-arrow-left-circle font-size-15"></i>
          </b-button>
          <b-button
            variant="primary"
            class="mt-1"
            @click="navegar('redesSociais', true)"
            data-tooltip="Próximo"
            data-tooltip-location="bottom"
          >
            <i class="mdi mdi-arrow-right-circle font-size-15"></i>
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      fields: [],
      optionTipoDeficiencia: [],
      deficiencias: [],
      loading: true,
      travaAdicionar: true,
      disabledSalvar: false,
      indexLoading: "",
      loadingSalvar: false,
      loadingDeletar: false,
    };
  },
  async created() {
    await this.preencheLookups();
  },
  methods: {
    navegar(nomeAba, direcao) {
      if (this.verificarCamposPreenchidos()) {
        this.$emit("navegar", nomeAba, direcao);
      } else {
        this.$tools.alerta(
          "Por favor, para continuar preencha todos os campos",
          "warning"
        );
      }
    },

    verificarCamposPreenchidos() {
      var dados = this.fields;
      for (let i = 0; i < dados.length; i++) {
        if (
          !dados[i].salvo ||
          dados[i].tipoDeficiencia === "" ||
          dados[i].dsCid === ""
        ) {
          return false;
        }
      }
      return true;
    },

    AddformData() {
      this.fields.push({ tipoDeficiencia: "", dsCid: "", salvo: false });
      this.travaAdicionar = true;
    },

    deleteRow(field, index) {
      this.loadingDeletar = true;
      this.indexLoading = index;
      if (field.id) {
        this.$http
          .delete("api/profileErp/deficiencias/" + field.id)
          .then(() => {
            this.fields.splice(index, 1);
            this.loadingDeletar = false;
            this.indexLoading = "";
          })
          .catch((err) => {
            this.loadingDeletar = false;
            this.indexLoading = "";
            this.$tools.alerta(err.response?.data?.message || "Erro ao excluir deficiência no ERP", "error");
          });
      } else {
        this.fields.splice(index, 1);
        this.loadingDeletar = false;
        this.indexLoading = "";
      }
      this.travaAdicionar = false;
    },

    async preencheLookups() {
      try {
        const [tiposDeficiencia, deficiencias] = await Promise.allSettled([
          this.$http.get("api/profileErp/tipos-deficiencia"),
          this.$http.get("api/profileErp/deficiencias"),
        ]);
        if (tiposDeficiencia.status !== "fulfilled") {
          throw tiposDeficiencia.reason;
        }

        const dadosTipos = tiposDeficiencia.value.data;
        const listaTipos = Array.isArray(dadosTipos)
          ? dadosTipos
          : dadosTipos?.Items || dadosTipos?.Data || dadosTipos?.data || [];
        this.optionTipoDeficiencia = listaTipos.map((item) => ({
          ...item,
          sq_deficiencia:
            item.Id || item.id || item.CodigoTipoDeficiencia || item.codigoTipoDeficiencia,
          nm_deficiencia: item.Descricao || item.descricao || "",
        }));
        if (deficiencias.status !== "fulfilled") {
          throw deficiencias.reason;
        }

        const dadosDeficiencias = deficiencias.value.data;
        this.deficiencias = Array.isArray(dadosDeficiencias)
          ? dadosDeficiencias
          : dadosDeficiencias?.Deficiencias || dadosDeficiencias?.Data || dadosDeficiencias?.data || [];
        this.deficiencias.forEach((el) => {
          const sqDef = el.IdDeficiencia || el.idDeficiencia || el.SQDEFICIENCIA || el.sqDeficiencia || "";
          const sqTipoDeficiencia = el.Deficiencia?.IdTipoDeficiencia
            || el.deficiencia?.idTipoDeficiencia
            || el.deficiencia?.idtipodeficiencia;
          const tipoDeficiencia = this.optionTipoDeficiencia.find(
            (def) => String(def.sq_deficiencia) === String(sqTipoDeficiencia || sqDef)
          );
          this.fields.push({
            tipoDeficiencia,
            dsCid: el.DSCID || el.dsCid || el.cid || el.Cid || "",
            salvo: true,
            id: el.Id || el.id || el.SQDEFICIENCIA || el.sqDeficiencia,
            idDeficiencia: sqDef,
          });
        });
        this.travaAdicionar = false;
      } catch (err) {
        this.$tools.alerta(
          err.response?.data?.message || "Não foi possível carregar os dados de PCD.",
          "error"
        );
      } finally {
        this.loading = false;
      }
    },

    salvar(field, index) {
      this.loadingSalvar = true;
      this.disabledSalvar = true;
      this.indexLoading = index;

      if (field.tipoDeficiencia.sq_deficiencia && field.dsCid !== "") {
        if (this.verificaCidIgual(field, index)) {
          var item = {
            IdDeficiencia: field.tipoDeficiencia.sq_deficiencia,
            Cid: field.dsCid,
            Situacao: "A",
          };
          this.$http.post("api/profileErp/deficiencias", item)
            .then((response) => {
              this.travaAdicionar = false;
              field.salvo = true;
              field.id = response.data.Id || response.data.id || response.data.SQDEFICIENCIA || response.data.sqDeficiencia;
              this.loadingSalvar = false;
              this.$tools.alerta("Cadastrado com sucesso", "success");
              this.disabledSalvar = false;
              this.indexLoading = "";
            })
            .catch((err) => {
              this.loadingSalvar = false;
              this.disabledSalvar = false;
              this.indexLoading = "";
              this.$tools.alerta(err.response?.data?.message || "Erro ao salvar deficiência no ERP", "error");
              console.log(err);
            });
          this.indexLoading = 0;
        }
        this.$emit("carregarNivelPerfil");
      } else {
        if (!field.tipoDeficiencia.sq_deficiencia && field.dsCid === "") {
          this.loadingSalvar = false;
          this.indexLoading = "";
          this.$tools.alerta(
            "Por favor, para continuar preencha todos os campos",
            "warning"
          );
          return;
        }

        if (!field.tipoDeficiencia.sq_deficiencia) {
          this.loadingSalvar = false;
          this.indexLoading = "";
          this.$tools.alerta(
            "Por favor, para continuar preencha todos os campos",
            "warning"
          );
          return;
        }

        if (field.dsCid === "") {
          this.loadingSalvar = false;
          this.indexLoading = "";
          this.$tools.alerta(
            "Por favor, para continuar preencha todos os campos",
            "warning"
          );
          return;
        }
      }
    },

    verificaCidIgual(field, index) {
      let igual = true;
      for (let idx = 0; idx < this.fields.length; idx++) {
        const el = this.fields[idx];
        if (idx !== index) {
          if (el.dsCid === field.dsCid) {
            this.$tools.alerta(
              "Não foi possível cadastrar pois o CID já foi cadastrado em outro registro",
              "warning"
            );
            igual = false;
            // } else if (
            //   el.tipoDeficiencia.sq_deficiencia ===
            //   field.tipoDeficiencia.sq_deficiencia
            // ) {
            //   this.$tools.alerta(
            //     "Não foi possível salvar a mesma deficiência duas vezes",
            //     "warning"
            //   );
            //   igual = false;
          }
        }
      }
      this.loadingSalvar = false;
      this.indexLoading = 0;
      return igual;
    },
  },
};
</script>
